var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "main-card-config" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
        },
        [
          _c(
            "div",
            { staticClass: "title-header" },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("config-manager::operate-config::title-header")
                  ) +
                  " "
              ),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: { effect: "dark", placement: "top-start" },
                },
                [
                  _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                    _c("div", { staticStyle: { width: "220px" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("config-manager::operate-config::title-tip")
                        )
                      ),
                    ]),
                  ]),
                  _c("i", { staticClass: "icon-a-01wenhao iconfont-el icon" }),
                ]
              ),
            ],
            1
          ),
          _c("p", { staticClass: "tips-info" }, [
            _vm._v(_vm._s(_vm.$t("config-manager::operate-config::title-sub"))),
          ]),
        ]
      ),
      _c(
        "el-form",
        { ref: "from", attrs: { model: _vm.form, "label-width": "0px" } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: "",
                prop: "predictRate",
                placeholder: _vm.$t(
                  "config-manager::operate-config::placehodler"
                ),
                rules: [
                  {
                    required: true,
                    message: _vm.$t(
                      "config-manager::operate-config::placehodler"
                    ),
                  },
                  {
                    type: "number",
                    message: _vm.$t(
                      "config-manager::operate-config::placehodler-number"
                    ),
                  },
                ],
              },
            },
            [
              _c("el-input-number", {
                staticClass: "input-item",
                attrs: { "controls-position": "right", min: 0, max: 100 },
                model: {
                  value: _vm.form.predictRate,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "predictRate", $$v)
                  },
                  expression: "form.predictRate",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  staticClass: "save-btn",
                  attrs: {
                    type: "primary",
                    loading: _vm.btnLoading,
                    size: "medium",
                  },
                  on: { click: _vm.onSave },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("config-manager::operate-config::save")) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }